import { render, staticRenderFns } from "./Datatables.vue?vue&type=template&id=9fe97e62&"
import script from "./Datatables.vue?vue&type=script&lang=ts&"
export * from "./Datatables.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('9fe97e62', component.options)
    } else {
      api.reload('9fe97e62', component.options)
    }
    module.hot.accept("./Datatables.vue?vue&type=template&id=9fe97e62&", function () {
      api.rerender('9fe97e62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/TorreControl/Datatables.vue"
export default component.exports